import axios from 'axios';
const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}

// ── Brand Ops → Audit (core team) ──
export async function getAuditOptions() {
  const res = await axios.get(`${API_BASE}/audit/options`, { headers: authHeader() });
  return res.data;
}
export async function previewAudit(filters) {
  const res = await axios.post(`${API_BASE}/audit/preview`, filters, { headers: authHeader() });
  return res.data;
}
export async function startAudit(filters, packer_id) {
  const res = await axios.post(`${API_BASE}/audit/start`, { filters, packer_id }, { headers: authHeader() });
  return res.data;
}
export async function getOngoingAudits() {
  const res = await axios.get(`${API_BASE}/audit/ongoing`, { headers: authHeader() });
  return res.data;
}
export async function getAuditReports() {
  const res = await axios.get(`${API_BASE}/audit/reports`, { headers: authHeader() });
  return res.data;
}
export async function getAuditReport(root_audit_id) {
  const res = await axios.get(`${API_BASE}/audit/report/${root_audit_id}`, { headers: authHeader() });
  return res.data;
}
export async function reassignAudit(audit_id, packer_id) {
  const res = await axios.post(`${API_BASE}/audit/${audit_id}/reassign`, { packer_id }, { headers: authHeader() });
  return res.data;
}
export async function cancelAudit(audit_id) {
  const res = await axios.post(`${API_BASE}/audit/${audit_id}/cancel`, {}, { headers: authHeader() });
  return res.data;
}
export async function closeAudit(audit_id, action) {
  const res = await axios.post(`${API_BASE}/audit/${audit_id}/close`, { action }, { headers: authHeader() });
  return res.data;
}

// ── Packer app ──
export async function packerMyAudits() {
  const res = await axios.get(`${API_BASE}/audit/packer/my-audits`, { headers: authHeader() });
  return res.data;
}
export async function packerAuditItems(audit_id) {
  const res = await axios.get(`${API_BASE}/audit/packer/${audit_id}`, { headers: authHeader() });
  return res.data;
}
export async function packerSaveAudit(audit_id, responses) {
  const res = await axios.post(`${API_BASE}/audit/packer/${audit_id}/save`, { responses }, { headers: authHeader() });
  return res.data;
}
export async function packerSubmitAudit(audit_id, responses) {
  const res = await axios.post(`${API_BASE}/audit/packer/${audit_id}/submit`, { responses }, { headers: authHeader() });
  return res.data;
}
export async function packerEnterBarcode(audit_id, barcode) {
  const res = await axios.post(`${API_BASE}/audit/packer/${audit_id}/barcode`, { barcode }, { headers: authHeader() });
  return res.data;
}
